import React, {useEffect, useMemo, useRef, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Link} from "react-router-dom";
import ClaimsService from "../../../services/ClaimsService";
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import Spinner from "reactjs-simple-spinner";
import EnhancedTable from "./tables/savingsDeathTableComponent/EnhancedTable";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import letterHeader from "../../../assets/images/letterhead.png";
import FilesService from "../../../services/FilesService";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid primary',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 20, 6),
        overflowY: 'scroll',
        marginTop: '5%',
        marginBottom: '5%',
        position: 'relative',
        height: '100%',
    },
}));

const SavingsDeath = (props) => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [claim, setClaim] = React.useState({});
    const [initialLoading, setInitialLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    //columns
    const columns = useMemo(
        () => [
            {
                Header: 'Policy Number',
                accessor: 'policy_number',
            },
            {
                Header: 'Name',
                accessor: 'first_name_of_assured',
            },
            {
                Header: 'Surname',
                accessor: 'last_name_of_assured',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Amount',
                accessor: 'amount_claimed',
            },
            {
                Header: 'Claim Status',
                accessor: 'claim_status',
            },
            {
                Header: 'Actions',
                accessor: 'id',
                Cell: ({row}) => (
                    <span>
                        <Link className="btn btn-info btn-sm" onClick={() => openEditClaimForm(row)}><i
                            className="fa fa-edit fa-2x"/></Link>
                        <Link className="btn btn-info btn-sm" onClick={() => viewRowClaim(row)}><i
                            className="fa fa-eye fa-2x"/> &nbsp;View</Link>

                        {/**/}
                        {row.original.claim_status === 'NEW' && (
                            <>
                                <Link className="btn btn-success btn-sm" onClick={() => authorizeClaim(row)}><i
                                    className="fa-solid fa-check-to-slot "></i> &nbsp;
                                    Authorize</Link>
                                <Link className="btn btn-warning btn-sm" onClick={() => suspendClaim(row)}><i
                                    className="fa-solid fa-circle-pause"/> &nbsp;Suspend</Link>
                                <Link className="btn btn-danger btn-sm" onClick={() => rejectClaim(row)}><i
                                    className="fa fa-remove fa-2x"/>&nbsp;&nbsp;Reject</Link>

                            </>
                        )}


                        {row.original.claim_status === 'AUTHORISED' && (
                            <>
                                <Link className="btn btn-success btn-sm" onClick={() => Pay(row)}>Pay &nbsp; <i
                                    className="fa-solid fa-money-bill"></i></Link>
                                <Link className="btn btn-warning btn-sm" onClick={() => suspendClaim(row)}><i
                                    className="fa-solid fa-circle-pause"/> &nbsp;Suspend</Link>
                                <Link className="btn btn-danger btn-sm" onClick={() => rejectClaim(row)}><i
                                    className="fa fa-remove "/>&nbsp;&nbsp;Reject</Link>
                            </>
                        )}

                        {/**/}
                        {row.original.claim_status === 'AWAITING_PAYMENT' && (
                            <>
                                <Link className="btn btn-success btn-sm" onClick={() => Pay(row)}>Pay &nbsp; <i
                                    className="fa-solid fa-money-bill"></i></Link>
                                <Link className="btn btn-warning btn-sm" onClick={() => suspendClaim(row)}><i
                                    className="fa-solid fa-circle-pause"/> &nbsp;Suspend</Link>
                                <Link className="btn btn-danger btn-sm" onClick={() => rejectClaim(row)}><i
                                    className="fa fa-remove "/>&nbsp;&nbsp;Reject</Link>
                            </>
                        )}

                        {/**/}
                        {row.original.claim_status === 'SUSPENDED' && (
                            <>
                                <Link className="btn btn-success btn-sm" onClick={() => authorizeClaim(row)}><i
                                    className="fa-solid fa-check-to-slot "></i> &nbsp;
                                    Authorize</Link>
                                <Link className="btn btn-danger btn-sm" onClick={() => rejectClaim(row)}><i
                                    className="fa fa-remove "/>&nbsp;&nbsp;Reject</Link>

                            </>
                        )}

                    </span>
                )
            },
        ],
        []
    )

    //view claim
    const viewRowClaim = (e) => {
        setMessage('')
        //store row record into localStorage
        console.log('A Td Element was clicked!')
        console.log('it produced this event:', e.original)
        setClaim(e.original);
        //show modal
        handleOpen();

    }

    //update claim
    const openEditClaimForm = (e) => {
        setMessage('')
        //store row record into localStorage
        console.log('A Td Element was clicked!')
        console.log('it produced this event:', e.original)
        //show modal
        localStorage.setItem('claim', JSON.stringify(e.original));
        props.history.push('/edit-savings-death-claim');

    }

    const [skipPageReset, setSkipPageReset] = useState(false)

// We need to keep the table from resetting the pageIndex when we
// Update data. So we can keep track of that flag with a ref.

// When our cell renderer calls updateMyData, we'll use
// the rowIndex, columnId and new value to update the
// original data

    const updateData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    /**
     * update status functions
     */

        //validate
    const validateClaim = (e) => {
            setLoading(true);
            console.log(e.original.id);
            //call validate method
            ClaimsService.validateClaim(e.original.id)
                .then(res => {
                    console.log(res);
                    if (res.status === 200) {
                        toast('Claim Status Updated', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        ClaimsService.getAllDeathClaims()
                            .then(res => {
                                console.log("data", res);
                                if (res.status === 200) {
                                    setData(res.data.claims);
                                    setLoading(false)
                                } else {
                                    setLoading(false);
                                    toast.warning('Failed To Load Data, Please Reload Page', {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: true,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                                }
                            })
                            .catch(err => {
                                setLoading(false)
                                toast.warning('Operation Failed, Error:' + err, {
                                    position: "top-center",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                console.log(err);
                            });
                    } else {
                        setLoading(false)
                        toast.warning('Operation Failed, error: ', {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                })
                .catch(err => {
                    setLoading(false)
                    toast.warning('Operation Failed, error: ' + err, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    console.log(err);
                });
        }

    //authorize
    const authorizeClaim = (e) => {
        setLoading(true);
        console.log(e.original.id);
        //call validate method
        ClaimsService.AuthorizeClaim(e.original.id)
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    toast('Claim Status Updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    ClaimsService.getAllDeathClaims()
                        .then(res => {
                            console.log("data", res);
                            if (res.status === 200) {
                                setData(res.data.claims);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                toast.warning('Failed To Load Data, Please Reload Page', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }
                        })
                        .catch(err => {
                            setLoading(false)
                            toast.warning('Operation Failed, Error:' + err, {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(err);
                        });
                } else {
                    setLoading(false)
                    toast.warning('Operation Failed, error: ', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, error: ' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });

    }

    //initiatePay
    const initiatePay = (e) => {
        setLoading(true);
        console.log(e.original.id);
        //call validate method
        ClaimsService.InitiatePay(e.original.id)
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    toast('Claim Status Updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    ClaimsService.getAllDeathClaims()
                        .then(res => {
                            console.log("data", res);
                            if (res.status === 200) {
                                setData(res.data.claims);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                toast.warning('Failed To Load Data, Please Reload Page', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }
                        })
                        .catch(err => {
                            setLoading(false)
                            toast.warning('Operation Failed, Error:' + err, {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(err);
                        });
                } else {
                    setLoading(false)
                    toast.warning('Operation Failed, error: ', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, error: ' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });

    }

    //pay
    const Pay = (e) => {
        setLoading(true);
        console.log(e.original.id);
        //call validate method
        ClaimsService.Pay(e.original.id)
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    toast('Claim Status Updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    ClaimsService.getAllDeathClaims()
                        .then(res => {
                            console.log("data", res);
                            if (res.status === 200) {
                                setData(res.data.claims);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                toast.warning('Failed To Load Data, Please Reload Page', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }
                        })
                        .catch(err => {
                            setLoading(false)
                            toast.warning('Operation Failed, Error:' + err, {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(err);
                        });
                } else {
                    setLoading(false)
                    toast.warning('Operation Failed, error: ', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, error: ' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });

    }

    //cancel claim
    const rejectClaim = (e) => {
        setLoading(true);
        console.log(e.original.id);
        //call validate method
        ClaimsService.RejectClaim(e.original.id)
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    toast('Claim Status Updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    ClaimsService.getAllDeathClaims()
                        .then(res => {
                            console.log("data", res);
                            if (res.status === 200) {
                                setData(res.data.claims);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                toast.warning('Failed To Load Data, Please Reload Page', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }
                        })
                        .catch(err => {
                            setLoading(false)
                            toast.warning('Operation Failed, Error:' + err, {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(err);
                        });
                } else {
                    setLoading(false)
                    toast.warning('Operation Failed, error: ', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, error: ' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });

    }

    //suspend claim
    const suspendClaim = (e) => {
        setLoading(true);
        console.log(e.original.id);
        //call validate method
        ClaimsService.suspendClaim(e.original.id)
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    toast('Claim Status Updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    ClaimsService.getAllFuneralClaims()
                        .then(res => {
                            console.log("data", res);
                            if (res.status === 200) {
                                setData(res.data.claims);
                                setLoading(false);
                            } else {
                                setLoading(false);
                                toast.warning('Failed To Load Data, Please Reload Page', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            }
                        })
                        .catch(err => {
                            setLoading(false)
                            toast.warning('Operation Failed, Error:' + err, {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(err);
                        });
                } else {
                    setLoading(false)
                    toast.warning('Operation Failed, error: ', {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, error: ' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });

    }

    /**
     * end functions
     */

    const [message, setMessage] = useState('');
    const [files, setFiles] = useState({});
    const [uploadLoading1, setUploadLoading1] = useState(false);

    const handleFileChange1 = (e) => {
        setUploadLoading1(true);
        console.log(e);
        const file = e.target.files[0];
        let name = e.target.name
        const formData = new FormData();
        formData.append("file", file);
        formData.append('policy_number', claim.policy_number)
        FilesService.savingsDeathUpload(formData)
            .then(res => {
                console.log(res);

                ClaimsService.updateClaimFile({
                    "id": claim.id, 'file': 1
                })
                    .then(response => {
                        console.log("response:- ", response)
                        if (response.status === 200) {
                            toast.success('Claim updated', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(e.target.name)
                            setMessage('Successful');
                            setFiles({...files, [name]: name})
                            setUploadLoading1(false);
                            setInitialLoading(true)
                            ClaimsService.getAllDeathClaims()
                                .then(res => {
                                    console.log(res);
                                    if (res.status === 200) {
                                        setData(res.data.claims);
                                        setInitialLoading(false)
                                    } else {
                                        setData([])
                                        setInitialLoading(false)
                                        toast.warning('Failed to get all death claims. Please Reload the page.', {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: true,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                        });
                                    }
                                }).catch(err => {
                                console.log(err);
                                setData([])
                                setInitialLoading(false)
                                toast.warning('Failed to get all death claims. Please Reload the page.', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            });
                        } else {
                            setMessage('')
                            toast.warning('Claim not updated', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            setUploadLoading1(false);
                        }
                    }).catch(error => {
                    console.log("error:- ", error)
                    toast.warning('Claim not updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setMessage('')
                    setUploadLoading1(false);
                })

            })
            .catch(err => {
                console.log(err);
                setMessage('');
                toast.warning('Upload Failed', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUploadLoading1(false);
            });
    }


    //get initial data
    useEffect(() => {
        setInitialLoading(true)
        ClaimsService.getAllDeathClaims()
            .then(res => {
                console.log(res);
                if (res.status === 200) {
                    setData(res.data.claims);
                    setInitialLoading(false)
                } else {
                    setData([])
                    setInitialLoading(false)
                    toast.warning('Failed to get all death claims. Please Reload the page.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            }).catch(err => {
            console.log(err);
            setData([])
            setInitialLoading(false)
            toast.warning('Failed to get all death claims. Please Reload the page.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });

    }, []);

    const ref = useRef();

    const [downloading, setDownloading] = useState(false);
    //download file
    const downloadFile = () => {
        setDownloading(true);
        console.log("id", claim.id)
        let id = parseInt(claim.id);
        FilesService.savingsDeathDownload(id)
            .then(res => {
                console.log("res", res);
                if (res.status === 200) {
                    toast.success('Download Successful', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setDownloading(false);
                } else {
                    console.log("res", res);
                    toast.warning('Download Failed', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setDownloading(false);
                }

            }).catch((err) => {
            setDownloading(false);
            toast.warning('Download Failed', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("err", err);
        })
    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>

                        <ReactToPrint content={() => ref.current}>
                            <PrintContextConsumer>
                                {({handlePrint}) => (
                                    <>
                                        <button className="btn btn-sm btn-secondary"
                                                onClick={handlePrint}>
                                            Print this out!&nbsp;<i className="fa fa-print"/>
                                        </button>
                                    </>

                                )}
                            </PrintContextConsumer>
                        </ReactToPrint>
                        <div ref={ref} className="row p-3">
                            <div className="col-md-8 container">
                                <div className="row">
                                    <img src={letterHeader} width="100%" height="20%" alt="Letter Head"/>
                                </div>
                                <table className="table p-3 table-borderless table-striped table-responsive">
                                    <tbody>
                                    <tr className="bg-white text-success font-weight-bold">
                                        <td colSpan={3}>
                                            <h3 className="mt-4"><b>Claim Details: {claim.policy_number}</b></h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-white text-success font-weight-bold">
                                            Status
                                        </td>
                                        {claim.claim_status === 'REJECTED' ? (
                                            <td colSpan={2} className="bg-white text-danger font-weight-bold">
                                                {claim.claim_status}
                                            </td>
                                        ) : claim.claim_status === 'SUSPENDED' ? (
                                            <td colSpan={2} className="bg-white text-warning font-weight-bold">
                                                {claim.claim_status}
                                            </td>
                                        ) : (
                                            <td colSpan={2} className="bg-white text-success font-weight-bold">
                                                {claim.claim_status}
                                            </td>
                                        )}


                                    </tr>
                            <tr className="bg-white text-success font-weight-bold">
                                <td>Name</td>
                                <td>Id Number</td>
                                <td>Email</td>
                            </tr>
                                    <tr>
                                        <td>{claim.first_name_of_assured}&nbsp;
                                            {claim.last_name_of_assured}
                                        </td>
                                        <td>{claim.id_number}</td>
                                        <td>{claim.email}</td>
                                    </tr>
                                    <tr className="bg-white text-success font-weight-bold">
                                        <td>Date of Death</td>
                                        <td>Cause Of Death</td>
                                    </tr>
                                    <tr>
                                        <td>{claim.deceased_date_of_death}

                                        </td>
                                        <td>{claim.deceased_cause_of_death}</td>
                                    </tr>
                                    <tr className="bg-white text-success font-weight-bold">
                                        <td>Amount Claimed</td>
                                        <td colSpan={4}>Postal Address</td>
                                    </tr>
                                    <tr>
                                        <td>{claim.amount_claimed}</td>
                                        <td colSpan={4}>{claim.postal_address}</td>

                                    </tr>
                                    <tr className="bg-white text-success font-weight-bold">
                                        <td colSpan={2}>Initiator</td>
                                        <td colSpan={2}>Modified By</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>{claim.created_by}</td>
                                        <td colSpan={2}>{claim.modified_by}</td>

                                    </tr>

                                    <tr className="bg-white text-success font-weight-bold">
                                        <td colSpan={2}>Created Date</td>
                                        <td colSpan={2}>Last Update</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>{claim.created_at}</td>
                                        <td colSpan={2}>{claim.updated_at}</td>

                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                        {downloading && (
                            <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Downloading file....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                        )}
                        {!downloading && (
                            <>
                                {claim.file === 0 || claim.file === "0" ? (
                                    <div className="row mb-4">
                                        <div className="col-md-6">

                                            <div className="row mb-3">
                                                {uploadLoading1 && (
                                                    <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Uploading File....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                                                )}
                                                {message !== '' && !uploadLoading1 && (
                                                    <span className="text-success">
                                        <br/>File Saved&nbsp;<i className="fa fa-check"/>
                                    </span>
                                                )}
                                                {message === '' && !uploadLoading1 && (
                                                    <div className="col-md-6 mb-2">

                                                        <label htmlFor="inputEmail4">Upload
                                                            Client Document</label>
                                                        <br/>
                                                        <label
                                                            className="text-muted text-sm-center">*
                                                            Select File</label>
                                                        &nbsp;&nbsp;
                                                        {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}

                                                        <div>
                                                            {message === '' && !uploadLoading1 && (
                                                                <label
                                                                    className="btn btn-sm btn-primary"
                                                                    htmlFor="my-file-selector">
                                                                    <input
                                                                        id="my-file-selector"
                                                                        type="file"
                                                                        name="claimantCertificate"
                                                                        style={{display: "none"}}
                                                                        accept=".pdf, .docx, .doc"
                                                                        onChange={handleFileChange1}
                                                                    />
                                                                    <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                                                    Browse
                                                                </label>
                                                            )}
                                                            <div className="p-3"/>
                                                        </div>
                                                    </div>
                                                )}


                                            </div>


                                        </div>
                                        <div className="col-md-3">
                                            <button className="btn btn-sm btn-danger font-weight-bold"
                                                    onClick={() => handleClose()}>Exit (
                                                X )
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-3">
                                            <button onClick={downloadFile} className="btn btn-sm btn-success">Download
                                                Claim
                                                Files&nbsp;<i
                                                    className="fa-solid fa-download"></i></button>
                                        </div>
                                        <div className="col-md-3">
                                            <button className="btn btn-sm btn-danger font-weight-bold"
                                                    onClick={() => handleClose()}>Exit (
                                                X )
                                            </button>
                                        </div>
                                    </div>
                                )}

                            </>
                        )}
                    </div>
                </Fade>
            </Modal>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content ">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/claims"><a href><i className="fa-solid fa-basket-shopping"/>&nbsp;Claims</a>
                            </Link>
                             &nbsp;|&nbsp;
                            <Link to="/savings-claims"><a href><i className="fa-solid fa-car-burst"/>&nbsp;Savings
                                Claims</a> </Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class">Death Claims</span>
                        </ul>
                        <div className="row mt bg-white">
                            <div className="col-lg-12">

                                {/*  table */}
                                {loading && (
                                    <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Updating Claim....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                                )}
                                {initialLoading && (
                                    <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Loading Claims....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                                )}
                                {!loading && !initialLoading && (
                                    <EnhancedTable
                                        columns={columns}
                                        data={data}
                                        setData={setData}
                                        updateMyData={updateData}
                                        skipPageReset={skipPageReset}
                                    />
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default SavingsDeath;
